// extracted by mini-css-extract-plugin
module.exports = {"dropin":"PaymentForm-module__dropin___1YiRK","payment_error":"PaymentForm-module__payment_error___1HASn"};